import { useState } from "react";
import { IconButton } from "@mui/material";
import { getCloseButtonSize, useIsMobile } from "../../../../utils";
import CloseIcon from "../../../../assets/icons/CloseIcon";
import { findBrandByDomain } from "../../../../configs/configLoader";
import { subtitlesStyles } from "../../../../configs";
import CloseIconGivency from "../../../../assets/icons/CloseIconGivency";
import { useTranslation } from "react-i18next";

import "./index.css";

interface CloseIconButtonProps {
  step: any | null;
  brandName?: string;
  titleStyles: any;
  closeIframe: () => void;
}

export const CloseIconButton = ({
  step,
  brandName,
  titleStyles,
  closeIframe,
}: CloseIconButtonProps) => {
  const isMobile = useIsMobile();

  const { t } = useTranslation("components/intro");

  const [hover, setHover] = useState(false);

  if (!step || step?.number < 0) return null;

  const brandDefined = findBrandByDomain();

  const isLeCollet = brandDefined?.name === "LeCollet";
  const isGivenchy = brandDefined?.name === "Givenchy";
  const isTDF = brandDefined?.name === "TDF";

  const getDynamicTop = (): string => {
    return isLeCollet ? "7px" : "10px";
  };

  const closeButtonSize = getCloseButtonSize(
    isMobile,
    brandName,
    { mobile: "12px", desktop: "18px" },
    { mobile: "18px", desktop: "20px" },
  );

  if (isGivenchy && !isMobile) {
    const textStyles = {
      ...subtitlesStyles,
      color: titleStyles.color ?? "black",
      fontSize: `calc(${subtitlesStyles.fontSize} - 1px)`,
      cursor: "pointer",
      position: isMobile ? "fixed" : "",
      right: "20px",
      top: getDynamicTop(),
      textTransform: "uppercase",
    };
    return (
      <span
        role="button"
        tabIndex={0}
        style={textStyles}
        onClick={closeIframe}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") closeIframe();
        }}
      >
        {t("Close")}
      </span>
    );
  }

  if (isTDF) {
    return (
      <div
        style={{
          display: "flex",
        }}
        onClick={closeIframe}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") closeIframe();
        }}
        role="button"
        tabIndex={0}
      >
        <span
          style={{
            position: "fixed",
            right: "50px",
            top: isMobile ? "25px" : "14px",
            fontSize: "14px",
          }}
        >
          Close
        </span>
        <IconButton
          aria-label="Close modal"
          className="close-icon"
          sx={{
            position: "fixed",
            right: "20px",
            top: isMobile ? "23px" : "12px",
          }}
        >
          <CloseIcon
            className="icon"
            style={{
              color: titleStyles.color ?? "black",
              width: "12px",
              height: "12px",
            }}
          />
        </IconButton>
      </div>
    );
  }

  if (isLeCollet) {
    return (
      <IconButton
        aria-label={t("Close")}
        onClick={closeIframe}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sx={{
          position: "fixed",
          right: "15px",
          top: getDynamicTop(),
          padding: 0,
        }}
      >
        <div
          style={{
            background: hover ? "#383838" : "black",
            padding: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background 0.25s ease, transform 0.25s ease",
            transform: hover ? "translateY(-2px)" : "translateY(0px)",
          }}
        >
          <CloseIcon
            style={{
              color: "white",
              width: closeButtonSize,
              height: closeButtonSize,
              transition: "transform 0.3s ease",
              transform: hover ? "rotate(180deg)" : "rotate(0deg)",
            }}
            fill="white"
          />
        </div>
      </IconButton>
    );
  }

  return (
    <IconButton
      aria-label={t("Close")}
      onClick={closeIframe}
      className="close-icon"
      sx={{
        position: "fixed",
        right: isGivenchy && isMobile ? "5px" : "20px",
        top: getDynamicTop(),
      }}
    >
      {isGivenchy && isMobile ? (
        <CloseIconGivency
          className="icon"
          style={{ width: "40px", height: "40px" }}
        />
      ) : (
        <CloseIcon
          className="icon"
          style={{
            color: titleStyles.color ?? "black",
            width: closeButtonSize,
            height: closeButtonSize,
          }}
        />
      )}
    </IconButton>
  );
};

export default CloseIconButton;
